/** @jsx jsx */
import { jsx } from '@emotion/core';
import {
  CardShowcase,
  Heading,
  ButtonPrimary,
  ButtonTertiary,
} from '@americanexpress/dls-react';
import PropTypes from 'prop-types';

export const FxActionCard = ({
  id,
  icon,
  heading,
  additionalDetail,
  primaryButtonLabel,
  onPrimaryButtonClick,
  tertiaryButtonLabel,
  onTertiaryButtonClick,
}) => {
  const primaryButton = primaryButtonLabel && onPrimaryButtonClick && (
    <ButtonPrimary
      id={`${id}-ButtonPrimary`}
      className="width-full"
      onClick={onPrimaryButtonClick}
    >
      {primaryButtonLabel}
    </ButtonPrimary>
  );

  const tertiaryButton = tertiaryButtonLabel && onTertiaryButtonClick && (
    <ButtonTertiary
      id={`${id}-ButtonTertiary`}
      className="width-full margin-1-t"
      onClick={onTertiaryButtonClick}
    >
      {tertiaryButtonLabel}
    </ButtonTertiary>
  );

  return (
    <CardShowcase className="col-lg-3 col-xs-12 margin-responsive-b">
      <div className="width-full pad-responsive">
        {icon}
        {heading && (
          <Heading level="4" headingStyle="heading3">
            {heading}
          </Heading>
        )}

        <div className="pad-1-tb" css={{ height: '40px' }}>{additionalDetail}</div>

        {(primaryButton || tertiaryButton) && (
          <div className="flex flex-column flex-align-items-center pad-responsive">
            {primaryButton}
            {tertiaryButton}
          </div>
        )}
      </div>
    </CardShowcase>
  );
};

FxActionCard.displayName = 'FxActionCard';

FxActionCard.propTypes = {
  id: PropTypes.string,
  heading: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  additionalDetail: PropTypes.node,
  primaryButtonLabel: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func,
  tertiaryButtonLabel: PropTypes.string,
  onTertiaryButtonClick: PropTypes.func,
};

FxActionCard.defaultProps = {
  id: 'actionCard',
  additionalDetail: null,
  primaryButtonLabel: '',
  onPrimaryButtonClick: null,
  tertiaryButtonLabel: '',
  onTertiaryButtonClick: null,
};
